import { createReducer } from '@reduxjs/toolkit'

import {
  fetchThreadCounters,
  unreadThreadsPatched,
  userCountersPatched,
} from 'apps/chat/actions/countersActions'
import { threadSocketUpdatedNotification } from 'apps/chat/actions/threadSocketUpdatedNotification'
import { setAssignee, threadUpdatedNotification } from 'apps/chat/actions/threadsActions'

import { CountersState } from '../models/chatInterfaces'

export const initialState: CountersState = {
  unreadThreads: null,
  users: null,
  isFetching: false,
  isThreadsAssignmentChanged: false,
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(setAssignee, (state) => {
      state.isThreadsAssignmentChanged = true
    })
    .addCase(threadUpdatedNotification, (state) => {
      state.isThreadsAssignmentChanged = true
    })
    .addCase(threadSocketUpdatedNotification, (state) => {
      state.isThreadsAssignmentChanged = true
    })
    .addCase(fetchThreadCounters.pending, (state) => {
      state.isFetching = true
      state.isThreadsAssignmentChanged = false
    })
    .addCase(fetchThreadCounters.fulfilled, (state, action) => {
      state.users = action.payload.users
      state.unreadThreads = action.payload.has_unread_threads
      state.isFetching = false
    })
    .addCase(fetchThreadCounters.rejected, (state) => {
      state.isFetching = false
    })
    .addCase(userCountersPatched, (state, action) => {
      if (!state.users) return

      const { user_id, account_id, thread_counters } = action.payload
      const userCountersIndex = state.users.findIndex((user) => user.user_id === user_id)
      if (userCountersIndex === -1) return

      state.users[userCountersIndex] = { account_id, user_id, thread_counters }
    })
    .addCase(unreadThreadsPatched, (state, action) => {
      state.unreadThreads = action.payload
    })
})
